module.exports = __webpack_public_path__ + "img/Mitra Dana Top Finance.88087c1f.png";